import { t } from "../../i18n";
import { useState, type ReactNode } from "react";

/** Liste satırlarında toplu seçim; listede artık olmayan kimlikler kendiliğinden düşer (silme/geri alma sonrası). */
export function useSelection(ids: string[]) {
  const [sel, setSel] = useState<ReadonlySet<string>>(new Set());
  const selected = ids.filter((id) => sel.has(id));
  const all = ids.length > 0 && selected.length === ids.length;
  return {
    selected, all, some: selected.length > 0 && !all,
    has: (id: string): boolean => sel.has(id),
    toggle: (id: string): void => setSel((s) => { const n = new Set(s); if (n.has(id)) n.delete(id); else n.add(id); return n; }),
    toggleAll: (): void => setSel(all ? new Set() : new Set(ids)),
    clear: (): void => setSel(new Set()),
  };
}
export type Selection = ReturnType<typeof useSelection>;

/** Başlık satırındaki "tümünü seç" kutusu (kısmi seçimde ara durum) */
export function SelectAllBox({ s, className = "" }: { s: Selection; className?: string }): JSX.Element {
  return <input type="checkbox" className={`align-middle ${className}`} checked={s.all} ref={(el) => { if (el) el.indeterminate = s.some; }} onChange={s.toggleAll} aria-label={t("Tümünü seç")} />;
}

/** Seçim varken tablonun üstünde: "N seçili" + toplu eylemler + seçimi kaldır */
export function BulkBar({ s, children, cad }: { s: Selection; children: ReactNode; cad: boolean }): JSX.Element | null {
  if (!s.selected.length) return null;
  return (
    <div role="toolbar" aria-label={t("Toplu işlem")} className={cad ? "flex items-center gap-1 px-2 py-1 bg-cad-head border-b border-cad-soft2 text-[11px]" : "flex items-center gap-2 py-2 text-sm"}>
      <span className={cad ? "mr-1 text-cad-ink2" : "mr-1"}>{s.selected.length} {t("seçili")}</span>
      {children}
      <button type="button" className={cad ? "ml-auto text-cad-accent hover:underline" : "ml-auto underline"} onClick={s.clear}>{t("Seçimi kaldır")}</button>
    </div>
  );
}
